import { useMemo } from "react";
import { tsr } from "~/utils/client";

export const useUnitAvailabilityData = () => {
  const { data: availabilityData } =
    tsr.reporting.listUnitAvailability.useQuery({
      queryKey: ["reporting", "unit-availability", "availability"],
      refetchInterval: 60000, // 1 minute
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: true,
    });

  const { data: polygonData } = tsr.reporting.listUnitPolygons.useQuery({
    queryKey: ["reporting", "unit-availability", "polygons"],
    staleTime: Infinity,
  });

  const polygons = polygonData?.body;
  const unitAvailability = availabilityData?.body;

  const unitAvailabilityMap = useMemo(() => {
    return new Map(unitAvailability?.map(item => [item.unitId, item]));
  }, [unitAvailability]);

  return {
    unitAvailabilityMap,
    polygons,
  };
};
